<template>
  <div class="central-and-western">
    <!-- 头部 -->
    <v-header></v-header>
    <!-- 广告 -->
    <div class="banner">
      <div class="bg"></div>
      <div class="center">
        <h1>{{ $t("message.central.banner.h") }}</h1>
        <p>{{ $t("message.central.banner.p") }}</p>
        <menubtn></menubtn>
      </div>
    </div>
    <!-- 内容 -->
    <div class="party-c">
      <!-- SEO -->
      <div class="center">
        <div class="seo">
          <h1>~{{ $t("message.central.content.h") }}~</h1>
          <div class="seo-show">
            <div>
              <img
                src="../assets/images/dinner2.png"
                alt
                width="100%"
                height="100%"
              />
            </div>
            <p>{{ $t("message.central.content.span1") }}</p>
            <p>{{ $t("message.central.content.span2") }}</p>
          </div>
        </div>
      </div>
    </div>
    <!-- 尾部 -->
  </div>
</template>

<script>
import header from "../components/header";
import menubtn from "../components/menubtn";
export default {
  name: "caterers",
  data() {
    return {};
  },
  components: {
    "v-header": header,
    menubtn
  }
};
</script>
<style scoped>
.center {
  width: 75%;
  margin: auto;
}
/* 广告 */
.banner {
  position: relative;
  width: 100%;
  height: 450px;
  background: url("../assets/images/equiry.png") no-repeat;
  background-size: 100% 100%;
  margin: 100px 0 0 0;
}
.banner h1,
.banner p {
  text-align: center;
  color: white;
}
.banner h1 {
  font-weight: bold;
  font-size: 50px;
}
.banner p {
  margin: 1% 0;
  font-size: 15px;
}
.banner .center {
  width: 80%;
  height: 40%;
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 3;
  margin: auto;
}
.banner .banner-call1 {
  font-weight: 200;
  color: #eb6410;
  letter-spacing: 0;
  margin: 0 0 3% 0;
  font-size: 1.1rem;
}
.seo {
  margin: 2% 0;
  overflow: hidden;
}
.seo-show {
  overflow: hidden;
  position: relative;
}
.seo h1 {
  text-align: center;
  color: #eb6410;
  font-weight: 300;
  margin-top: 2%;
}
.seo-show > div {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  float: left;
  width: 200px;
  padding: 0 3%;
  box-sizing: border-box;
}
.seo img {
  width: 250px;
}
.seo p {
  float: right;
  margin: 2% auto;
  font-size: 14px;
  width: 70%;
  text-indent: 2rem;
}
@media (max-width: 820px) {
  .banner h1 {
    font-size: 25px;
  }
  .banner {
    height: 300px;
  }
  /* seo */
  .seo h1 {
    font-size: 1.4rem;
    margin: 3% 0;
  }
  .seo p {
    width: 100%;
    font-weight: 400;
    padding: 0 3%;
    box-sizing: border-box;
  }
  .center {
    width: 100%;
  }
  .seo-show > div {
    width: 100%;
    position: static;
    top: 0;
    transform: translateY(0);
    float: none;
  }
  .seo img {
    width: 100%;
  }
}
</style>
<style>
.central-and-western .banner .el-button.el-button--success {
  display: block;
  width: 100%;
  background: #eb6410;
  border: 1px solid #eb6410;
}
.central-and-western .banner .el-dialog {
  margin-top: 12vh !important;
}
.central-and-western .banner .el-dialog__body {
  padding: 0 33px 0 0 !important;
}
.central-and-western .el-scrollbar__view.el-time-spinner__list li,
.el-scrollbar__view.el-select-dropdown__list li {
  display: block;
}
</style>
